// source: type/address.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.type.AddressMsg', null, global);
goog.exportSymbol('proto.type.ShippingAddressMsg', null, global);
goog.exportSymbol('proto.type.ShippingAddressMsg.AccessType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.AddressMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.AddressMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.AddressMsg.displayName = 'proto.type.AddressMsg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.ShippingAddressMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.ShippingAddressMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.ShippingAddressMsg.displayName = 'proto.type.ShippingAddressMsg';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.AddressMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.type.AddressMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.AddressMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AddressMsg.toObject = function(includeInstance, msg) {
  var f, obj = {
    uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    line1: jspb.Message.getFieldWithDefault(msg, 2, ""),
    line2: jspb.Message.getFieldWithDefault(msg, 3, ""),
    line3: jspb.Message.getFieldWithDefault(msg, 4, ""),
    city: jspb.Message.getFieldWithDefault(msg, 5, ""),
    province: jspb.Message.getFieldWithDefault(msg, 6, ""),
    zipcode: jspb.Message.getFieldWithDefault(msg, 7, ""),
    countrycode: jspb.Message.getFieldWithDefault(msg, 8, ""),
    other: jspb.Message.getFieldWithDefault(msg, 9, ""),
    updated: (f = msg.getUpdated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.AddressMsg}
 */
proto.type.AddressMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.AddressMsg;
  return proto.type.AddressMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.AddressMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.AddressMsg}
 */
proto.type.AddressMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLine1(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLine2(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLine3(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setProvince(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipcode(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountrycode(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setOther(value);
      break;
    case 40:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdated(value);
      break;
    case 41:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.AddressMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.AddressMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.AddressMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AddressMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLine1();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLine2();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLine3();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getProvince();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getZipcode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCountrycode();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getOther();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUpdated();
  if (f != null) {
    writer.writeMessage(
      40,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      41,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string UUID = 1;
 * @return {string}
 */
proto.type.AddressMsg.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.AddressMsg} returns this
 */
proto.type.AddressMsg.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string line1 = 2;
 * @return {string}
 */
proto.type.AddressMsg.prototype.getLine1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.AddressMsg} returns this
 */
proto.type.AddressMsg.prototype.setLine1 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string line2 = 3;
 * @return {string}
 */
proto.type.AddressMsg.prototype.getLine2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.AddressMsg} returns this
 */
proto.type.AddressMsg.prototype.setLine2 = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string line3 = 4;
 * @return {string}
 */
proto.type.AddressMsg.prototype.getLine3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.AddressMsg} returns this
 */
proto.type.AddressMsg.prototype.setLine3 = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string city = 5;
 * @return {string}
 */
proto.type.AddressMsg.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.AddressMsg} returns this
 */
proto.type.AddressMsg.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string province = 6;
 * @return {string}
 */
proto.type.AddressMsg.prototype.getProvince = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.AddressMsg} returns this
 */
proto.type.AddressMsg.prototype.setProvince = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string zip_code = 7;
 * @return {string}
 */
proto.type.AddressMsg.prototype.getZipcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.AddressMsg} returns this
 */
proto.type.AddressMsg.prototype.setZipcode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string countryCode = 8;
 * @return {string}
 */
proto.type.AddressMsg.prototype.getCountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.AddressMsg} returns this
 */
proto.type.AddressMsg.prototype.setCountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string other = 9;
 * @return {string}
 */
proto.type.AddressMsg.prototype.getOther = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.AddressMsg} returns this
 */
proto.type.AddressMsg.prototype.setOther = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional google.protobuf.Timestamp updated = 40;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.type.AddressMsg.prototype.getUpdated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 40));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.type.AddressMsg} returns this
*/
proto.type.AddressMsg.prototype.setUpdated = function(value) {
  return jspb.Message.setWrapperField(this, 40, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.AddressMsg} returns this
 */
proto.type.AddressMsg.prototype.clearUpdated = function() {
  return this.setUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.AddressMsg.prototype.hasUpdated = function() {
  return jspb.Message.getField(this, 40) != null;
};


/**
 * optional google.protobuf.Timestamp created = 41;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.type.AddressMsg.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 41));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.type.AddressMsg} returns this
*/
proto.type.AddressMsg.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 41, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.AddressMsg} returns this
 */
proto.type.AddressMsg.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.AddressMsg.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 41) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.ShippingAddressMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.type.ShippingAddressMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.ShippingAddressMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.ShippingAddressMsg.toObject = function(includeInstance, msg) {
  var f, obj = {
    locationName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    roomDetails: jspb.Message.getFieldWithDefault(msg, 2, ""),
    address: (f = msg.getAddress()) && proto.type.AddressMsg.toObject(includeInstance, f),
    curbside: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    insideAccessibilityPainfull: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    access: jspb.Message.getFieldWithDefault(msg, 6, 0),
    floor: jspb.Message.getFieldWithDefault(msg, 7, 0),
    company_name: jspb.Message.getFieldWithDefault(msg, 8, ""),
    contactFirstname: jspb.Message.getFieldWithDefault(msg, 9, ""),
    contactLastname: jspb.Message.getFieldWithDefault(msg, 10, ""),
    contactPhone: jspb.Message.getFieldWithDefault(msg, 11, ""),
    digicode: jspb.Message.getFieldWithDefault(msg, 12, ""),
    building: jspb.Message.getFieldWithDefault(msg, 13, ""),
    requiresLicencePlate: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    returnContactPhone: jspb.Message.getFieldWithDefault(msg, 15, ""),
    distanceTruckDeliveryPoint: jspb.Message.getFieldWithDefault(msg, 16, 0),
    misc: jspb.Message.getFieldWithDefault(msg, 17, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.ShippingAddressMsg}
 */
proto.type.ShippingAddressMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.ShippingAddressMsg;
  return proto.type.ShippingAddressMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.ShippingAddressMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.ShippingAddressMsg}
 */
proto.type.ShippingAddressMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocationName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomDetails(value);
      break;
    case 3:
      var value = new proto.type.AddressMsg;
      reader.readMessage(value,proto.type.AddressMsg.deserializeBinaryFromReader);
      msg.setAddress(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCurbside(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInsideAccessibilityPainfull(value);
      break;
    case 6:
      var value = /** @type {!proto.type.ShippingAddressMsg.AccessType} */ (reader.readEnum());
      msg.setAccess(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFloor(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactFirstname(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactLastname(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setContactPhone(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setDigicode(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuilding(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequiresLicencePlate(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setReturnContactPhone(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDistanceTruckDeliveryPoint(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setMisc(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.ShippingAddressMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.ShippingAddressMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.ShippingAddressMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.ShippingAddressMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocationName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoomDetails();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddress();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.type.AddressMsg.serializeBinaryToWriter
    );
  }
  f = message.getCurbside();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getInsideAccessibilityPainfull();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getAccess();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getFloor();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getCompanyName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getContactFirstname();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getContactLastname();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getContactPhone();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getDigicode();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getBuilding();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getRequiresLicencePlate();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getReturnContactPhone();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getDistanceTruckDeliveryPoint();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getMisc();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.type.ShippingAddressMsg.AccessType = {
  GROUNDFLOOR: 0,
  WITHELEVATOR: 1,
  WITHOUTELEVATOR: 2
};

/**
 * optional string location_name = 1;
 * @return {string}
 */
proto.type.ShippingAddressMsg.prototype.getLocationName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.ShippingAddressMsg} returns this
 */
proto.type.ShippingAddressMsg.prototype.setLocationName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string room_details = 2;
 * @return {string}
 */
proto.type.ShippingAddressMsg.prototype.getRoomDetails = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.ShippingAddressMsg} returns this
 */
proto.type.ShippingAddressMsg.prototype.setRoomDetails = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional AddressMsg address = 3;
 * @return {?proto.type.AddressMsg}
 */
proto.type.ShippingAddressMsg.prototype.getAddress = function() {
  return /** @type{?proto.type.AddressMsg} */ (
    jspb.Message.getWrapperField(this, proto.type.AddressMsg, 3));
};


/**
 * @param {?proto.type.AddressMsg|undefined} value
 * @return {!proto.type.ShippingAddressMsg} returns this
*/
proto.type.ShippingAddressMsg.prototype.setAddress = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.ShippingAddressMsg} returns this
 */
proto.type.ShippingAddressMsg.prototype.clearAddress = function() {
  return this.setAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.ShippingAddressMsg.prototype.hasAddress = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool curbside = 4;
 * @return {boolean}
 */
proto.type.ShippingAddressMsg.prototype.getCurbside = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.type.ShippingAddressMsg} returns this
 */
proto.type.ShippingAddressMsg.prototype.setCurbside = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool inside_accessibility_painfull = 5;
 * @return {boolean}
 */
proto.type.ShippingAddressMsg.prototype.getInsideAccessibilityPainfull = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.type.ShippingAddressMsg} returns this
 */
proto.type.ShippingAddressMsg.prototype.setInsideAccessibilityPainfull = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional AccessType access = 6;
 * @return {!proto.type.ShippingAddressMsg.AccessType}
 */
proto.type.ShippingAddressMsg.prototype.getAccess = function() {
  return /** @type {!proto.type.ShippingAddressMsg.AccessType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.type.ShippingAddressMsg.AccessType} value
 * @return {!proto.type.ShippingAddressMsg} returns this
 */
proto.type.ShippingAddressMsg.prototype.setAccess = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional int32 floor = 7;
 * @return {number}
 */
proto.type.ShippingAddressMsg.prototype.getFloor = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.type.ShippingAddressMsg} returns this
 */
proto.type.ShippingAddressMsg.prototype.setFloor = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string company_name = 8;
 * @return {string}
 */
proto.type.ShippingAddressMsg.prototype.getCompanyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.ShippingAddressMsg} returns this
 */
proto.type.ShippingAddressMsg.prototype.setCompanyName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string contact_firstname = 9;
 * @return {string}
 */
proto.type.ShippingAddressMsg.prototype.getContactFirstname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.ShippingAddressMsg} returns this
 */
proto.type.ShippingAddressMsg.prototype.setContactFirstname = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string contact_lastname = 10;
 * @return {string}
 */
proto.type.ShippingAddressMsg.prototype.getContactLastname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.ShippingAddressMsg} returns this
 */
proto.type.ShippingAddressMsg.prototype.setContactLastname = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string contact_phone = 11;
 * @return {string}
 */
proto.type.ShippingAddressMsg.prototype.getContactPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.ShippingAddressMsg} returns this
 */
proto.type.ShippingAddressMsg.prototype.setContactPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string digicode = 12;
 * @return {string}
 */
proto.type.ShippingAddressMsg.prototype.getDigicode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.ShippingAddressMsg} returns this
 */
proto.type.ShippingAddressMsg.prototype.setDigicode = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string building = 13;
 * @return {string}
 */
proto.type.ShippingAddressMsg.prototype.getBuilding = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.ShippingAddressMsg} returns this
 */
proto.type.ShippingAddressMsg.prototype.setBuilding = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional bool requires_licence_plate = 14;
 * @return {boolean}
 */
proto.type.ShippingAddressMsg.prototype.getRequiresLicencePlate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.type.ShippingAddressMsg} returns this
 */
proto.type.ShippingAddressMsg.prototype.setRequiresLicencePlate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional string return_contact_phone = 15;
 * @return {string}
 */
proto.type.ShippingAddressMsg.prototype.getReturnContactPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.ShippingAddressMsg} returns this
 */
proto.type.ShippingAddressMsg.prototype.setReturnContactPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional int32 distance_truck_delivery_point = 16;
 * @return {number}
 */
proto.type.ShippingAddressMsg.prototype.getDistanceTruckDeliveryPoint = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.type.ShippingAddressMsg} returns this
 */
proto.type.ShippingAddressMsg.prototype.setDistanceTruckDeliveryPoint = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional string misc = 17;
 * @return {string}
 */
proto.type.ShippingAddressMsg.prototype.getMisc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.ShippingAddressMsg} returns this
 */
proto.type.ShippingAddressMsg.prototype.setMisc = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


goog.object.extend(exports, proto.type);
